import React from 'react';
import { UserLink } from '@sierralabs/user-ui';
import { useDocumentListPageContext } from '../DocumentListPageContext';
const DocumentUserLink = props => {
    const { toUserPath } = useDocumentListPageContext();
    return React.createElement(UserLink, Object.assign({ to: toUserPath }, props));
};
export default DocumentUserLink;
//# sourceMappingURL=DocumentUserLink.js.map